import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SubTableCard } from '../../tabs/embedded/SubTableCard';
import { subTablesOf } from '../../tabs/embedded/subTablesOf';
import type { ISubTablesProps } from './ISubTablesProps';

/**
 * Друга секція «Подробиці» вкладки «Загальне» (прототип v4, subSecs): під групами полів, перед «Пов’язаними записами» — картки підтаблиць
 * (дочірні типи з ознакою підтаблиці у визначенні) колонками від 460px; таблиці, що мають секцію «Пов’язані записи» у визначенні
 * (помічники мандата), показуються там.
 */
export function SubTables({ ws, module, rt, record }: ISubTablesProps) {
  const { t } = useTranslation();
  const tables = useMemo(() => subTablesOf(module, rt).filter((d) => !rt.related.some((x) => x.module === d.child.key)), [module, rt]);
  if (!tables.length) return null;
  return (
    <section className="rec-section" aria-label={t('recordPage.general.details')}>
      <div className="rec-section__title">{t('recordPage.general.details')}</div>
      <div className="rec-section__grid rec-section__grid--sub">
        {tables.map((d) => <SubTableCard key={d.key} ws={ws} moduleKey={module.module.key} def={d} parent={record} />)}
      </div>
    </section>
  );
}
